import { render, staticRenderFns } from "./confirmCustomerGetPrize.vue?vue&type=template&id=4400e3d4"
import script from "./confirmCustomerGetPrize.vue?vue&type=script&lang=js"
export * from "./confirmCustomerGetPrize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports